/* =========================================================
   TJD Pop-Up System — Trigger & Submission Logic
   =========================================================
   Preview any popup instantly (bypasses timers & cookies):
     ?tjd_popup=bridal-exit
     ?tjd_popup=statement-exit
     ?tjd_popup=lina-exit
   ========================================================= */

(function () {
  'use strict';

  var COOKIE_POPUP = 'tjd_popup_seen';
  var COOKIE_DAYS  = 7;
  var REDUCED      = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var popupShown   = false; // in-memory guard: at most one open per page view

  // ── Preview mode (URL param bypasses all gates) ─────────
  var params    = new URLSearchParams(window.location.search);
  var previewId = params.get('tjd_popup');
  var isPreview = !!previewId;

  // ── Cookie helpers ───────────────────────────────────────
  function setCookie(name, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().startsWith(name + '=');
    });
  }

  // ── Particle system ──────────────────────────────────────
  function pRand(a, b) { return Math.random() * (b - a) + a; }

  function makePopupParticle(type) {
    var base = { type: type, x: 0, y: 0, swayPhase: pRand(0, Math.PI * 2) };
    if (type === 'bokeh') {
      return Object.assign({}, base, {
        size: pRand(30, 80), speed: pRand(0.03, 0.10), opacity: pRand(0.06, 0.14),
        swayAmp: pRand(0.04, 0.14), swayFreq: pRand(0.001, 0.004),
        r: 210, g: 175, b: 80
      });
    }
    if (type === 'star') {
      return Object.assign({}, base, {
        size: pRand(2.5, 6.0), speed: pRand(0.05, 0.14), opacity: pRand(0.14, 0.45),
        swayAmp: pRand(0.08, 0.26), swayFreq: pRand(0.002, 0.007),
        glintPhase: pRand(0, Math.PI * 2), glintFreq: pRand(0.010, 0.030),
        rotation: pRand(0, Math.PI / 4), rotSpeed: pRand(-0.004, 0.004)
      });
    }
    var gold = Math.random() > 0.40;
    return Object.assign({}, base, {
      type: 'spark',
      size: pRand(0.7, 2.2), speed: pRand(0.10, 0.35), opacity: pRand(0.42, 0.88),
      swayAmp: pRand(0.12, 0.52), swayFreq: pRand(0.003, 0.011),
      glintPhase: pRand(0, Math.PI * 2), glintFreq: pRand(0.022, 0.065),
      r: gold ? 218 : 255, g: gold ? 178 : 252, b: gold ? 72 : 240
    });
  }

  function drawBokeh(ctx, p, sx) {
    var g = ctx.createRadialGradient(sx, p.y, 0, sx, p.y, p.size);
    g.addColorStop(0,    'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + p.opacity + ')');
    g.addColorStop(0.42, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + (p.opacity * 0.36) + ')');
    g.addColorStop(1,    'rgba(' + p.r + ',' + p.g + ',' + p.b + ',0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(sx, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
  }

  function drawSpark(ctx, p, sx, frame) {
    var tw = 0.5 + 0.5 * Math.sin(frame * p.glintFreq + p.glintPhase);
    var op = p.opacity * (0.36 + 0.64 * tw);
    var halo = ctx.createRadialGradient(sx, p.y, 0, sx, p.y, p.size * 6);
    halo.addColorStop(0, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + (op * 0.28) + ')');
    halo.addColorStop(1, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',0)');
    ctx.fillStyle = halo;
    ctx.beginPath();
    ctx.arc(sx, p.y, p.size * 6, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + op + ')';
    ctx.beginPath();
    ctx.arc(sx, p.y, p.size, 0, Math.PI * 2);
    ctx.fill();
  }

  function drawStar(ctx, p, sx, frame) {
    var tw = 0.5 + 0.5 * Math.sin(frame * p.glintFreq + p.glintPhase);
    var op = p.opacity * (0.28 + 0.72 * tw);
    var sz = p.size  * (0.72 + 0.28 * tw);
    p.rotation += p.rotSpeed;
    ctx.save();
    ctx.translate(sx, p.y);
    ctx.rotate(p.rotation);
    ctx.globalAlpha = op;
    var glow = ctx.createRadialGradient(0, 0, 0, 0, 0, sz * 5);
    glow.addColorStop(0, 'rgba(255,252,228,0.65)');
    glow.addColorStop(1, 'rgba(255,252,228,0)');
    ctx.fillStyle = glow;
    ctx.beginPath();
    ctx.arc(0, 0, sz * 5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'rgba(255,254,244,0.98)';
    ctx.beginPath();
    for (var i = 0; i < 8; i++) {
      var angle = (i / 8) * Math.PI * 2 - Math.PI / 2;
      var r     = i % 2 === 0 ? sz : sz * 0.11;
      var px    = Math.cos(angle) * r;
      var py    = Math.sin(angle) * r;
      i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
    }
    ctx.closePath();
    ctx.fill();
    ctx.globalAlpha = op * 0.32;
    ctx.strokeStyle = 'rgba(255,248,210,1)';
    ctx.lineWidth   = 0.6;
    ctx.beginPath(); ctx.moveTo(-sz * 3, 0);   ctx.lineTo(sz * 3, 0);   ctx.stroke();
    ctx.beginPath(); ctx.moveTo(0, -sz * 1.7);  ctx.lineTo(0, sz * 1.7); ctx.stroke();
    ctx.restore();
  }

  function initPopupCanvas(canvas) {
    if (!canvas || canvas._tjdInited) return;
    canvas._tjdInited = true;
    var modal = canvas.closest('.tjd-popup-modal');
    if (!modal) return;
    var ctx    = canvas.getContext('2d');
    var rafId  = null;
    var frame  = 0;
    var particles = [];

    function buildParticles() {
      canvas.width  = modal.offsetWidth;
      canvas.height = modal.offsetHeight;
      particles = [];
      var i;
      for (i = 0; i < 5; i++) {
        var b = makePopupParticle('bokeh');
        b.x = pRand(0, canvas.width); b.y = pRand(0, canvas.height);
        particles.push(b);
      }
      for (i = 0; i < 20; i++) {
        var s = makePopupParticle('spark');
        s.x = pRand(0, canvas.width); s.y = pRand(0, canvas.height);
        particles.push(s);
      }
      for (i = 0; i < 3; i++) {
        var t = makePopupParticle('star');
        t.x = pRand(0, canvas.width); t.y = pRand(0, canvas.height);
        particles.push(t);
      }
    }

    window.addEventListener('resize', function () {
      if (rafId) buildParticles();
    }, { passive: true });

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      frame++;
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.y -= p.speed;
        if (p.y + (p.size || 0) < 0) {
          p.y = canvas.height + (p.size || 4);
          p.x = pRand(0, canvas.width);
        }
        var sx = p.x + Math.sin(frame * p.swayFreq + p.swayPhase) * (p.swayAmp || 0) * 55;
        if (p.type === 'bokeh') drawBokeh(ctx, p, sx);
        else if (p.type === 'star') drawStar(ctx, p, sx, frame);
        else drawSpark(ctx, p, sx, frame);
      }
      rafId = requestAnimationFrame(animate);
    }

    canvas.startParticles = function () {
      buildParticles();
      if (!REDUCED && !rafId) rafId = requestAnimationFrame(animate);
    };

    canvas.stopParticles = function () {
      cancelAnimationFrame(rafId);
      rafId = null;
    };
  }

  // ── Overlay open / close ─────────────────────────────────
  function openOverlay(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-active');
    var canvas = el.querySelector('.tjd-popup-canvas');
    if (canvas) setTimeout(function () { canvas.startParticles && canvas.startParticles(); }, 60);
  }

  function closeOverlay(id, setMainCookie) {
    var el = document.getElementById(id);
    if (el) {
      el.classList.remove('is-active');
      var canvas = el.querySelector('.tjd-popup-canvas');
      if (canvas) canvas.stopParticles && canvas.stopParticles();
    }
    if (setMainCookie && !isPreview) setCookie(COOKIE_POPUP, COOKIE_DAYS);
  }

  // ── Single gated trigger — every trigger routes through here ──
  // Honors the 7-day cookie AND an in-memory flag, then writes the
  // cookie the instant the popup opens so no other trigger (timer,
  // scroll, or exit-intent) can re-open it this visit or this week.
  function triggerPopup(id) {
    if (popupShown || getCookie(COOKIE_POPUP)) return;
    popupShown = true;
    setCookie(COOKIE_POPUP, COOKIE_DAYS);
    openOverlay(id);
  }

  // ── AJAX form submit → success message → auto-close ─────
  function wireForm(formId, overlayId, successId) {
    var form = document.getElementById(formId);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);

      fetch('/contact', { method: 'POST', body: data, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          // Meta pixel — Lead. Gated on a REAL success: fetch() only rejects on network
          // failure, so this .then() also runs on a 4xx/5xx. Firing Lead unconditionally
          // here would pump failed submissions into the pixel as fake leads.
          if (typeof fbq === 'function' && res && (res.ok || res.redirected)) {
            try {
              fbq('track', 'Lead', {
                content_name:     'Exit-Intent Popup',
                content_category: formId.replace('tjd-form-', '').replace('-exit', '')
              });
            } catch (e) {}
          }

          form.style.display = 'none';
          var s = document.getElementById(successId);
          if (s) s.classList.add('is-visible');
          if (!isPreview) setCookie(COOKIE_POPUP, COOKIE_DAYS);
          setTimeout(function () { closeOverlay(overlayId, false); }, 2400);
        })
        .catch(function () { form.submit(); });
    });
  }

  // ── Exit-intent (cursor leaves toward top of viewport) ──
  function onExitIntent(cb) {
    var fired = false;
    document.addEventListener('mouseleave', function (e) {
      if (!fired && e.clientY <= 4) { fired = true; cb(); }
    });
  }

  // ── Scroll depth trigger ─────────────────────────────────
  function onScrollDepth(pct, cb) {
    var fired = false;
    window.addEventListener('scroll', function () {
      if (fired) return;
      var scrollable = document.body.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      if ((window.scrollY / scrollable) * 100 >= pct) {
        fired = true;
        cb();
      }
    }, { passive: true });
  }

  // ── Page path helpers ────────────────────────────────────
  var path = window.location.pathname;

  var isBridalHub = /^\/(pages\/bridal|pages\/fine-jewelry)/.test(path);
  var isLinaPDP   = /^\/products\/lina/.test(path);
  var isStatement = /^\/(pages\/statement|pages\/custom-inquiry)/.test(path);

  // ── Init ─────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    // Pre-init all canvases (sizes them while modal is in DOM)
    document.querySelectorAll('.tjd-popup-canvas').forEach(function (c) {
      initPopupCanvas(c);
    });

    // ── Preview mode: open named popup after 400 ms ───────
    if (isPreview) {
      var previewTarget = 'tjd-popup-' + previewId;
      setTimeout(function () {
        openOverlay(previewTarget);
      }, 400);
    }

    // ── Global: close on overlay backdrop click ───────────
    document.querySelectorAll('.tjd-popup-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeOverlay(overlay.id, true);
      });
    });

    // ── Global: close / skip buttons ─────────────────────
    document.querySelectorAll('.tjd-popup-close, .tjd-popup-skip').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var overlay = btn.closest('.tjd-popup-overlay');
        if (overlay) closeOverlay(overlay.id, true);
      });
    });

    if (isPreview) return;

    // ── Pop-Up 2: Bridal/Fine — exit intent + 25s timer + 40% scroll ──
    if (isBridalHub && !getCookie(COOKIE_POPUP)) {
      onExitIntent(function () { triggerPopup('tjd-popup-bridal-exit'); });
      setTimeout(function () { triggerPopup('tjd-popup-bridal-exit'); }, 25000);
      onScrollDepth(40, function () { triggerPopup('tjd-popup-bridal-exit'); });

      wireForm('tjd-form-bridal-exit', 'tjd-popup-bridal-exit', 'tjd-success-bridal-exit');
    }

    // ── Pop-Up 3: Statement — exit intent + 25s timer + 40% scroll ──
    if (isStatement && !getCookie(COOKIE_POPUP)) {
      onExitIntent(function () { triggerPopup('tjd-popup-statement-exit'); });
      setTimeout(function () { triggerPopup('tjd-popup-statement-exit'); }, 25000);
      onScrollDepth(40, function () { triggerPopup('tjd-popup-statement-exit'); });

      wireForm('tjd-form-statement-exit', 'tjd-popup-statement-exit', 'tjd-success-statement-exit');
    }

    // ── Pop-Up 5: Lina — exit intent + 25s timer + 40% scroll ────────
    if (isLinaPDP && !getCookie(COOKIE_POPUP)) {
      onExitIntent(function () { triggerPopup('tjd-popup-lina-exit'); });
      setTimeout(function () { triggerPopup('tjd-popup-lina-exit'); }, 25000);
      onScrollDepth(40, function () { triggerPopup('tjd-popup-lina-exit'); });

      wireForm('tjd-form-lina-exit', 'tjd-popup-lina-exit', 'tjd-success-lina-exit');
    }

  });

}());
